import React from 'react';
import { func } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';

const EditButton = ({ onClick }) => (
    <button className="edit-button" onClick={onClick}>
        <I18n k="layout.global_messages.user_activation.change_email"/>
    </button>
);

EditButton.propTypes = {
    onClick: func.isRequired
};

export default EditButton;
